let splashes = document.querySelectorAll(".splash")
let mvhide = document.querySelector(".mv__hide")

window.addEventListener("load", () => {
    if (!sessionStorage.getItem('splashed') && location.pathname == "/") {

        noscroll()
        splashes.forEach((splash) => {
            splash.classList.add("splash-is-on")
        })
        mvhide.style.display = "none"
        sessionStorage.setItem('splashed', true);
        setTimeout(() => {
            document.querySelector(".usemodal").classList.add("is-on")
        }, 3200)

    } else if (location.pathname == "/") {

        splashes.forEach((splash) => {
            splash.classList.add("afterSplash-is-on")
        })
        mvhide.style.display = "none"
    }
})

// const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent)

// if(isIOS){
//     sessionStorage.removeItem('splashed');
// }

function noscroll() {
    document.addEventListener('touchmove', disableScroll, {
        passive: false
    });
    document.addEventListener('mousewheel', disableScroll, {
        passive: false
    });
    setTimeout(() => {
        document.removeEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.removeEventListener('mousewheel', disableScroll, {
            passive: false
        });
    }, 2800);
}

function disableScroll(event) {
    event.preventDefault();
}